module.exports = __webpack_public_path__ + "img/android-setting.9c4e4041.png";